import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sem-resultados',
    templateUrl: './sem-resultados.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class SemResultadosComponent {
  @Input() titulo = 'Nenhum resultado encontrado.';
  @Input() subtitulo = '';
}
